module.exports = __webpack_public_path__ + "324d18267e1bcfdc09da1a3782db62cf.png";